import { render, staticRenderFns } from "./StepNewFlow.vue?vue&type=template&id=1a6fadbe&"
import script from "./StepNewFlow.vue?vue&type=script&lang=js&"
export * from "./StepNewFlow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1a6fadbe')) {
      api.createRecord('1a6fadbe', component.options)
    } else {
      api.reload('1a6fadbe', component.options)
    }
    module.hot.accept("./StepNewFlow.vue?vue&type=template&id=1a6fadbe&", function () {
      api.rerender('1a6fadbe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/chile/approvals/wizardFlow/wizard/flow/StepNewFlow.vue"
export default component.exports